import React from 'react';
import {
  TopNav,
  Logo,
  SearchBar,
  ShoppingCart,
  UserNav,
  BreadCrumb,
  PostDemand,
  HotLine
} from './sub-header';
import {connect} from 'react-redux';
import {setDataBreadCrumb} from 'actions';

class Header extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      opened: false,
      scrollTop: '',
      dataBreadcrumb: this.props.dataBreadcrumb,
      hasBreadcrumb: false
    };
    this.props.dispatch(setDataBreadCrumb(false, []));
  }

  componentDidMount() {
    this.setState({hasBreadcrumb: this.props.hasBreadcrumb, dataBreadcrumb: this.props.dataBreadcrumb})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dataBreadcrumb != nextProps.dataBreadcrumb) {
      this.setState({hasBreadcrumb: nextProps.hasBreadcrumb, dataBreadcrumb: nextProps.dataBreadcrumb});
    }
  }

  openMenu() {
    this.setState({scrollTop: window.scrollY})
    this.setState({opened: true});
    setTimeout(function() {
      let style = 'position: fixed; width: 100%; minHeight: 100mvh'
      document.getElementById('root').setAttribute("style", style);
    }, 400);
  }

  closeMenu() {
    document.getElementById('root').setAttribute("style", "");
    window.scrollTo(0, this.state.scrollTop);
    this.setState({opened: false});
  }

  render() {
    return (
      <div className={'header ' + `${this.state.opened
        ? 'menu-open'
        : ''}`} id='header'>
        <div className={'wrap-container ' + `${this.state.opened
          ? 'menu-open'
          : ''}`}>
          <div className='center'>
            <div className='wrap-nav-top'>
              <Logo/>
              <SearchBar/>
              <ShoppingCart/>
              <UserNav/>
              <button className='btn-toggle-nav-mobile fa fa-bars' onClick={this.openMenu.bind(this)}></button>
            </div>
            <div className={'nav-menu-mobile ' + `${this.state.opened
              ? 'menu-open'
              : ''}`}>
              <SearchBar/>
              <UserNav/>
              <button className='btn-toggle-nav-mobile fa fa-times' onClick={this.closeMenu.bind(this)}></button>
            </div>
          </div>
        </div>
        {this.state.hasBreadcrumb == true
          ? (<BreadCrumb data={this.state.dataBreadcrumb} classBreadcrumb={this.props.classBreadcrumb}/>)
          : null
}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {hasBreadcrumb: state.breadcrumb.hasBreadcrumb, dataBreadcrumb: state.breadcrumb.data};
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./components/layouts/master/Header.jsx